export const shopAndLearn = [
	{text: 'Store', link: 'store'},
	{text: 'Mac', link: 'mac'},
	{text: 'iPad', link: 'ipad'},
	{text: 'iPhone', link: 'iphone'},
	{text: 'Watch', link: 'watch'},
	{text: 'AirPods', link: 'airpods'},
	{text: 'TV & Home', link: 'tv-&-home'},
	{text: 'AirTag', link: 'air-tag'},
	{text: 'Accessories', link: 'accessories'},
	{text: 'Gift Cards', link: 'gift-cards'},
];

export const services = [
	{text: 'Apple Music', link: 'apple-music'},
	{text: 'Apple TV+', link: 'apple-tv-plus'},
	{text: 'Apple Arcade', link: 'apple-arcade'},
	{text: 'iCloud', link: 'i-cloud'},
	{text: 'Apple One', link: 'apple-one'},
	{text: 'Apple Books', link: 'apple-books'},
	{text: 'Apple Podcasts', link: 'apple-podcasts'},
	{text: 'App Store', link: 'app-store'},
];

export const account = [
	{text: 'Manage Your Apple ID', link: 'manage-your-apple-id'},
	{text: 'Apple Store Account', link: 'apple-store-account'},
	{text: 'iCloud.com', link: 'iCloud.com'},
];

export const appleStore = [
	{text: 'Apple Store App', link: 'apple-store-app'},
	{text: 'Apple Recycling Program', link: 'apple-recycling-program'},
	{text: 'Order Status', link: 'order-status'},
	{text: 'Shopping Help', link: 'shopping-help'},
];

export const forBusiness = [
	{text: 'Apple and Business', link: 'apple-and-business'},
];

export const forEducation = [
	{text: 'Apple and Education', link: 'apple-and-education'},
];

export const appleValues = [
	{text: 'Accessibility', link: 'accessibility'},
	{text: 'Environment', link: 'environment'},
	{text: 'Privacy', link: 'privacy'},
	{text: 'Supplier Responsibility', link: 'supplier-responsibility'},
];

export const aboutApple = [
	{text: 'Investors', link: 'investors'},
	{text: 'Ethics & Compliance', link: 'ethics-&-compliance'},
	{text: 'Events', link: 'events'},
	{text: 'Contact Apple', link: 'contact-apple'},
];

export const copyrightLinks = [
	{text: 'Privacy Policy', link: 'privacy-policy'},
	{text: 'Terms of Use', link: 'terms-of-use'},
	{text: 'Sales and Refunds', link: 'sales-and-refunds'},
	{text: 'Legal', link: 'legal'},
	{text: 'Site Map', link: 'site-map'},
];
